import { IDetectorModel } from "../../models/DetectorModel";
import { IBleSensorInformation } from "../../models/BleSensorInformation";

export interface IDetectorResponseModel {
  id: string;
  favoriteName: string;
  sensorInformation: IBleSensorInformation;
  detectorType: string;
  customName: string;
  macAddress: string;
  projectName: string;
  pinCode: string;
  createdAt: string;
  updatedAt: string;
  userConfigModel: string;
  sensorProfile: string;
  zones: string;
  isFavorite: boolean;
  settingType: string;
  hvacShortAddressExternalRelay: number;
  cutOffShortAddressExternalRelay: number;
  wiredPushButtonModel: string;
  blePushButtonModel: string;
  daliPushButtonModel: string;
  daliRotaryListModel: string;
  getSetTunableWhiteListModelReply: string;
  getSetTunableWhitePresetModelReply: string;
  daliDeviceDataScenesModelReplies: any[];
  getSetWirelessLinkFunctionModelReply: string;
}


export const mapFromDetectorResponseToIDetectorModel = (
  data: IDetectorResponseModel
): IDetectorModel => ({
  sensorSettingId: data.id,
  favoriteName: data.favoriteName,
  detectorType: data.sensorInformation.detectorType,
  macAddress: data.macAddress,
  customName: data.customName,
  projectName: data.projectName,
  pinCode: data.pinCode,
  lastUpload: data.updatedAt,
  sensorInformation: data.sensorInformation,
  userConfigModel: data.userConfigModel,
  sensorProfile: data.sensorProfile,
  zones: data.zones,
  isFavorite: data.isFavorite,
  bleSensorInformationId: data.sensorInformation.id,
  zonesToSend: data.zones,
  settingType: data.settingType,
  hvacShortAddressExternalRelay: data.hvacShortAddressExternalRelay,
  cutOffShortAddressExternalRelay: data.cutOffShortAddressExternalRelay,
  wiredPushButtonModel: data.wiredPushButtonModel,
  blePushButtonModel: data.blePushButtonModel,
  daliPushButtonModel: data.daliPushButtonModel,
  daliRotaryListModel: data.daliRotaryListModel,
  getSetTunableWhiteListModelReply: data.getSetTunableWhiteListModelReply,
  getSetTunableWhitePresetModelReply: data.getSetTunableWhitePresetModelReply,
  daliDeviceDataScenesModelReplies: data.daliDeviceDataScenesModelReplies,
  getSetWirelessLinkFunctionModelReply: data.getSetWirelessLinkFunctionModelReply
});
